import { connect } from 'react-redux';
import { DateString } from '../../common/commonModels';
import ManifestingPage from './ManifestingPage';
import { changeSelectedDate } from '../../trucks/trucksActions';
import { Truck, TruckStatus } from '../../models/truck';
import { ManifestStatus } from '../../models/manifest';
import { getLinehaulCompanies } from '../../store/actions/linehaul-company';
import { getCustomsBrokers } from '../../store/actions/customs-broker';
import { getLoadingRestrictions } from '../../store/actions/loading-restriction';
import momentTimezone from 'moment-timezone';
import { injectModal } from '../../contexts/modal-context';
import { getTrucks } from '../../store/actions/truck';
import { getTruckTemplates } from '../../store/actions/truck-template';
import { StoreState } from '../../store/state';

const mapStateToProps = (state: StoreState) => {
  const selectedLocation = state.location;
  const { timezone, dateFormat } = selectedLocation.localeSettings;
  const selectedDate = state.trucks.selectedDate
    || momentTimezone.tz(timezone).format(dateFormat).toString() as DateString;
  const trucks = Object.values(state.trucks.all);
  return {
    selectedLocation,
    selectedDate,
    trucks,
    isFetchingLocations: false,
    isFetchingTrucks: state.trucks.isLoading,
    autoRefresh: setAutoRefresh(trucks),
  };
};

function setAutoRefresh(trucks: Truck[]): boolean {
  return trucks.some(truck => {
    if (truck.status === TruckStatus.CLOSED && !truck.manifest) {

      // Manifesting initiated
      return true;
    }
    if (truck.manifest && truck.manifest.status === ManifestStatus.IN_PROGRESS) {

      // Manifesting in progress
      return true;
    }
    return false;
  });
}

const mapDispatchToProps = {
  changeSelectedDate,
  getTrucks: getTrucks.request,
  getCustomsBrokers: getCustomsBrokers.request,
  getLinehaulCompanies: getLinehaulCompanies.request,
  getTruckTemplates: getTruckTemplates.request,
  getTruckLoadingRestrictions: getLoadingRestrictions.request,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectModal(ManifestingPage));
